import {useState} from "react";
import { PlusOutlined } from '@ant-design/icons';
import { Image, Upload } from 'antd';
import type { GetProp, UploadFile, UploadProps } from 'antd';
import add from "../../image/icon_add.png";
import {LGBTButton} from "../lgbtButton/LGBTButton";
import { filesImage } from "../../models/commonModels";

export const UploadFileUI =({onFilesChange,onUploadFileChange}:{onFilesChange:(files:filesImage[])=>void,onUploadFileChange:(files:UploadFile[])=>void})=>{
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<UploadFile[]>([]);

    const setFileListFunc =(files:UploadFile<any>[])=>{
        setFileList(files);
        updateFiles(files)
    }

     async function updateFiles(files:UploadFile<any>[]) {
        var images:filesImage[] = [];
        await files.map(async (file)=>{
            if (!file.url && !file.preview) {
                file.preview = await getBase64(file.originFileObj as FileType);
            }
            const imageBase64 = file.preview as string
            const fImageItem:filesImage = {fName:file.name, fDataBase64:imageBase64.split(',')[1]}
            images.push(fImageItem)
        })
       
        onFilesChange(images)
        onUploadFileChange(files)
    }



    type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

    const getBase64 = (file: FileType): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as FileType);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) =>
        setFileListFunc(newFileList);

    const uploadButton = (
        <LGBTButton onClick={()=>{}} isBorder={true} colors={["#50964E", "#50964E"]} children={(<div style={{display:"flex", flexDirection:"row", justifyContent:"space-between", alignItems:"center",padding:"14px", width:"100%", height:"100%"}}>
                    <div style={{height:"100%", display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                        <img src={add} style={{maxWidth:"30px", maxHeight:"30px"}}/>
                    </div>
                    
                    <span style={{display:"flex", justifyContent:"center", alignItems:"center", flexGrow:"1"}}>Прикрепите подтверждающее фото</span>
                </div>)} textColor={"black"}/>
       
    );

    const clearButton = (
        <LGBTButton onClick={()=>{setFileListFunc([])}} isBorder={true} children={(<div style={{display:"flex", flexDirection:"row", justifyContent:"space-between",padding:"14px", width:"100%"}}>
            <img src={add} style={{maxWidth:"30px", height:"auto"}}/>
            <span>Удалить фото</span>
        </div>)} textColor={"black"}/>
    )

    return(
        <div style={{maxWidth:"95vw"}}>
            <>
                <Upload
                    style={{width:"100%", background:"none", border:"none"}}
                    beforeUpload={()=> {
                        /* update state here */
                        return false; }}
                    // accept={"image/jpeg"}
                    listType="picture"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                >
                    {fileList.length >= 4 ? null : uploadButton}
                </Upload>
                {previewImage && (
                    <div style={{border:"solid 1px green", borderRadius:"6px", width:"100%"}}>
                        <Image
                            wrapperStyle={{ display: 'none' }}
                            preview={{
                                visible: previewOpen,
                                onVisibleChange: (visible) => setPreviewOpen(visible),
                                afterOpenChange: (visible) => !visible && setPreviewImage(''),
                            }}
                            src={previewImage}
                        />
                    </div>
                )}
            </>
        </div>
    )
}
